<div class="container container-inner" *ngIf="loadingBolletta$()">
  <ngx-mare-skeleton [grid]="'1x4'" [template]="['title']"></ngx-mare-skeleton>
  <ngx-mare-skeleton [grid]="'1x3'" [template]="['title']"></ngx-mare-skeleton>
  <ngx-mare-skeleton [grid]="'1x5'" [template]="['title']"></ngx-mare-skeleton>
  <ngx-mare-skeleton [grid]="'1x3'" [template]="['title']"></ngx-mare-skeleton>
</div>

<ng-container *ngIf="!loadingBolletta$()">
  <ng-container *ngIf="hasBolletta$(); else noBolletta">
    <div class="container container-inner">
      <div class="table-container mb--24" *ngIf="table1">
        <!-- Tabella 1: indicatori -->
        <div class="table-heading">
        <h4>{{ 'bolletta.table_1.title' | translate }}</h4>
        <div class="table-caption mb--16 bg-base bg-sky p--16 rounded">
          <span class="fs-16"[innerHTML]="'bolletta.table_1.description' | translate " ></span>
        </div>
        <!-- <app-help-inline [title]="'bolletta.table_1.title' | translate" [description]="'bolletta.table_1.description' | translate"></app-help-inline> -->
        </div>
        <div class="table-wrapper rounded mb--48" *ngIf="table1">
          <table class="mat-elevation-z0 mat-table-responsive style-3 mat-mdc-table mat-mdc-table ">
            <thead>
              <tr class="mat-mdc-header-row bg-base bg-sky">
                <th class="mat-mdc-header-cell bg-base bg-sky">Elemento</th>
                <th class="mat-mdc-header-cell bg-base bg-sky">Stato (%)</th>
                <th class="mat-mdc-header-cell bg-base bg-sky">Commento</th>
                <th class="mat-mdc-header-cell bg-base bg-sky">Azione</th>
                <!-- <th class="mat-mdc-header-cell">Area</th>
                  <th class="mat-mdc-header-cell">Suggerimenti</th> -->
              </tr>
            </thead>
            <tbody class="mdc-data-table__content">
              <ng-container *ngFor="let area of areas">
                <ng-container *ngIf="table1[area].length > 0">
                  <ng-container *ngFor="let partner of table1[area]">
                    <tr *ngFor="let kpi of partner.kpis; let i = index">
                      <td class="mat-mdc-cell"><b>{{kpi.kpi}}</b><br />{{ kpi.title }}</td>
                      <td class="mat-mdc-cell">{{ kpi.value }}%</td>
                      <td class="mat-mdc-cell">{{ kpi.description }}</td>
                      <td class="mat-mdc-cell">{{ kpi.action }}</td>
                      <!-- <td class="mat-mdc-cell" *ngIf="i === 0" [attr.rowspan]="partner.kpis.length">{{areaMap[area]}}</td>
                            <td class="mat-mdc-cell" *ngIf="i === 0" [attr.rowspan]="partner.kpis.length">
                              {{ partner.suggestions }}
                            </td> -->
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-container mb--24" *ngIf="table2">
        <!-- Tabella 2: calcolo economico -->
        <h4>{{ 'bolletta.table_2.title' | translate }}</h4>
        <div class="table-caption mb--16 bg-base bg-peach p--16 rounded">
          <span class="fs-16"[innerHTML]=" 'bolletta.table_2.description' | translate"></span>
        </div>
        <div class="table-wrapper rounded mb--48" *ngIf="table2">
        <table class="mat-elevation-z0 mat-table-responsive style-3 mat-mdc-table">
          <thead>
            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell bg-base bg-peach">Elemento</th>
              <th class="mat-mdc-header-cell bg-base bg-peach">Impatto azione</th>
              <th class="mat-mdc-header-cell bg-base bg-peach">Valore economico (€)</th>
            </tr>
          </thead>
          <tbody class="mdc-data-table__content">
            <tr *ngFor="let row of table2">
              <td class="mat-mdc-cell"> <b>{{ row.kpi_name }}</b><br />{{ row.title }}</td>
              <td class="mat-mdc-cell">
                <ol [class.list-unstyled]="row.descriptions?.length === 1">
                  <li *ngFor="let description of row.descriptions">{{ description }}</li>
                </ol>
              </td>
              <td class="mat-mdc-cell">{{ row.total_price | currency: 'EUR' }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      <div class="table-container mb--24" *ngIf="table3">
        <!-- Tabella 3: Bilancio finale e success fee-->
        <h4>{{ 'bolletta.table_3.title' | translate }}</h4>
        <div class="table-caption mb--16  bg-base bg-teal p--16 rounded">
          <span class="fs-16"[innerHTML]="'bolletta.table_3.description' | translate"></span>
        </div>
        <div class="table-wrapper rounded mb--48" *ngIf="table3">
        <table class="mat-elevation-z0 mat-table-responsive style-3 mat-mdc-table">
          <!-- <thead>
            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell">Nome Obiettivo</th>
              <th class="mat-mdc-header-cell">Descrizioni</th>
              <th class="mat-mdc-header-cell">Prezzo Totale (€)</th>
              <th class="mat-mdc-header-cell">Beneficio Totale (€)</th>
              <th class="mat-mdc-header-cell">Percentuale di Copertura (%)</th>
              <th class="mat-mdc-header-cell">Prezzo Netto Benefici (€)</th>
            </tr>
          </thead> -->
          <tbody class="mdc-data-table__content">
            <tr *ngIf="table3.totalInvestment" class="bg-teal bg-base">
              <th class="mat-mdc-cell fw-bold bg-teal bg-base" colspan="1">Investimento Nominale:</th>
              <td class="mat-mdc-cell fw-bold text-center" colspan="4">{{ table3.totalInvestment | currency:'EUR' }}
              </td>
            </tr>
            <tr>
              <th>Obiettivo</th>
              <th>Impatto azione</th>
              <th>Investimento lordo</th>
              <!-- <th>Beneficio</th> -->
              <th>Copertura</th>
              <th>Investimento netto</th>
            </tr>
            <tr *ngFor="let row of table3.objectives">
              <td class="mat-mdc-cell">{{ row.area_name }}</td>
              <!-- <td class="mat-mdc-cell">{{ row.descriptions?.length >0 ? row.descriptions : 'Nessuna descrizione'  }}</td> -->
              <td class="mat-mdc-cell">
                <ol [class.list-unstyled]="row.descriptions?.length === 1" *ngIf="row.descriptions?.length >0; else noDescription">
                  <li *ngFor="let description of row.descriptions">{{ description }}</li>
                </ol>
                <ng-template #noDescription>
                  <span class="fs-16" [innerHTML]="'Nessuna descrizione' | translate"></span>
                </ng-template>
              </td>
              <td class="mat-mdc-cell">{{ row.totalPrice | currency:'EUR' }}</td>
              <!-- <td class="mat-mdc-cell">{{ row.totalBenefit | currency:'EUR' }}</td> -->
              <td class="mat-mdc-cell">{{ row.coveragePercentage }} %</td>
              <td class="mat-mdc-cell">{{ row.priceAfterBenefit | currency:'EUR' }}</td>
            </tr>
            <tr *ngIf="table3.realInvestment" class="bg-teal bg-base">
              <th class="mat-mdc-cell fw-bold bg-teal bg-base" colspan="1">Investimento Reale: </th>
              <td class="mat-mdc-cell fw-bold text-center" colspan="4">{{ table3.realInvestment | currency:'EUR' }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      <div class="table-container mb--24" *ngIf="table4">
        <h4>{{ 'bolletta.table_4.title' | translate }}</h4>
        <div class="table-caption mb--16  bg-base bg-blue p--16 rounded">
          <span class="fs-16"[innerHTML]="'bolletta.table_4.description' | translate"></span>
        </div>
        <div class="table-wrapper rounded mb--48" *ngIf="table4">
        <table class="mat-elevation-z0 mat-table-responsive style-3 mat-mdc-table">
          <thead>
            <tr class="mat-mdc-row ">
              <th class="mat-mdc-header-cell bg-base bg-blue fw-bold" colspan="2">Obiettivo Raggiunto</th>
              <th class="mat-mdc-header-cell bg-base bg-blue fw-bold">Beneficio Azienda</th>
              <th class="mat-mdc-header-cell bg-base bg-blue fw-bold">Nostre competenze su beneficio</th>
            </tr>
          </thead>
          <tbody class="mdc-data-table__content">

            <tr *ngFor="let row of table4.objectives; let i = index">
              <td class="mat-mdc-cell">{{ row.name }}</td>
              <td class="mat-mdc-cell">{{ row.percentage }} %</td>
              <td class="mat-mdc-cell">{{ row.value | currency:'EUR' }}</td>
              <td class="mat-mdc-cell" *ngIf="i===0" [rowSpan]="table4.objectives.length"></td>
            </tr>
            <tr *ngIf="table4.benefitSum">
              <td class="mat-mdc-cell bg-base bg-blue fw-bold" colspan="3">Somma benefici: {{ table4.benefitSum |
                currency:'EUR' }}</td>
              <td class="mat-mdc-cell bg-base bg-blue text-center fw-bold fs-24" rowspan="3">{{ table4.competence |
                currency:'EUR' }}</td>
            </tr>
            <tr *ngIf="table4.realInvestment">
              <td class="mat-mdc-cell bg-base bg-blue fw-bold" colspan="3">- Investimento Reale: {{ table4.realInvestment |
                currency:'EUR' }}</td>
            </tr>
            <tr *ngIf="table4.total">
              <td class="mat-mdc-cell bg-base bg-blue fw-bold" colspan="3">Totale: {{ table4.total | currency:'EUR' }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #noBolletta>
  <company-data-error [errors]="bollettaAnalizingErrors$()"></company-data-error>
</ng-template>